"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AchievementType;
(function (AchievementType) {
    AchievementType[AchievementType["SUN_FLOWER"] = 0] = "SUN_FLOWER";
    AchievementType[AchievementType["CERTIFICATE"] = 1] = "CERTIFICATE";
    AchievementType[AchievementType["FULL_SCORE"] = 100] = "FULL_SCORE";
    AchievementType[AchievementType["TOP_TEN"] = 101] = "TOP_TEN";
    AchievementType[AchievementType["CONTINUOUS_THREE_DAYS"] = 102] = "CONTINUOUS_THREE_DAYS";
    AchievementType[AchievementType["COMPLETED_THREE_LESSONS"] = 103] = "COMPLETED_THREE_LESSONS";
    AchievementType[AchievementType["CLOCK_IN"] = 104] = "CLOCK_IN";
})(AchievementType = exports.AchievementType || (exports.AchievementType = {}));
var AchievementSource;
(function (AchievementSource) {
    AchievementSource[AchievementSource["ENROLLMENT"] = 0] = "ENROLLMENT";
})(AchievementSource = exports.AchievementSource || (exports.AchievementSource = {}));
var CollectableType;
(function (CollectableType) {
    CollectableType[CollectableType["STUDY_TIME"] = 0] = "STUDY_TIME";
    CollectableType[CollectableType["HIGHACCURACY"] = 1] = "HIGHACCURACY";
    CollectableType[CollectableType["ACCURACY"] = 2] = "ACCURACY";
    CollectableType[CollectableType["SPEED"] = 3] = "SPEED";
    CollectableType[CollectableType["CERTIFICATE"] = 4] = "CERTIFICATE";
})(CollectableType = exports.CollectableType || (exports.CollectableType = {}));
var CollectableSource;
(function (CollectableSource) {
    CollectableSource[CollectableSource["EVALUATION"] = 0] = "EVALUATION";
    CollectableSource[CollectableSource["ENROLLMENT"] = 1] = "ENROLLMENT";
})(CollectableSource = exports.CollectableSource || (exports.CollectableSource = {}));
//# sourceMappingURL=achievement.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/achievement.js
// module id = 998
// module chunks = 0